import React, { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import logo from '../assets/Kuddlecore-Logo.png';
import ThemeSelector from '../context/ThemeSelector';
import '../styles/Sidebar.css';

const Sidebar = () => {
  const [reminderCount, setReminderCount] = useState(0);

  useEffect(() => {
    const fetchReminderCount = async () => {
      try {
        const token =
          sessionStorage.getItem("kuddleToken") ||
          localStorage.getItem("kuddleToken");

        const res = await fetch("/api/reminders/count", {
          headers: {
            Authorization: token ? `Bearer ${token}` : "",
          },
        });

        if (!res.ok) return;

        const data = await res.json();
        setReminderCount(data.count || 0);
      } catch (err) {
        console.warn("Reminder count unavailable");
      }
    };

    fetchReminderCount();
  }, []);

  return (
    <aside className="sidebar">
      <div className="sidebar-header">
        <img src={logo} alt="Kuddlecore Logo" className="logo" />
      </div>

      <nav>
        <ul>
          <li><NavLink to="/" className={({ isActive }) => isActive ? 'active' : ''}>KuddleBoard</NavLink></li>
          <li><NavLink to="/command-center" className={({ isActive }) => isActive ? 'active' : ''}>Command Center</NavLink></li>
          <li><NavLink to="/profile" className={({ isActive }) => isActive ? 'active' : ''}>Profile</NavLink></li>
          <li><NavLink to="/students" className={({ isActive }) => isActive ? 'active' : ''}>Students</NavLink></li>
          <li><NavLink to="/teachers" className={({ isActive }) => isActive ? 'active' : ''}>Teachers</NavLink></li>
          <li><NavLink to="/attendance" className={({ isActive }) => isActive ? 'active' : ''}>Attendance</NavLink></li>
          <li><NavLink to="/messages" className={({ isActive }) => isActive ? 'active' : ''}>Messages</NavLink></li>
          <li><NavLink to="/reports" className={({ isActive }) => isActive ? 'active' : ''}>Reports</NavLink></li>
          <li><NavLink to="/chatlogs" className={({ isActive }) => isActive ? 'active' : ''}>Chat Logs</NavLink></li>
          <li>
            <NavLink to="/reminders" className={({ isActive }) => isActive ? "active" : ""}>
              Reminders {reminderCount > 0 && <span className="sidebar-badge">{reminderCount}</span>}
            </NavLink>
          </li>
          <li><NavLink to="/analytics/sessions" className={({ isActive }) => isActive ? 'active' : ''}>Session Analytics</NavLink></li>
          <li>
            <NavLink
              to="/trash"
              className={({ isActive }) => (isActive ? "active" : "")}
            >
              Recycle Bin
            </NavLink>
          </li>
          <li><NavLink to="/settings" className={({ isActive }) => isActive ? 'active' : ''}>Settings</NavLink></li>
          <li>
            <NavLink
              to="/settings/folders"
              className={({ isActive }) => (isActive ? "active settings-link" : "settings-link")}
            >
              ⚙️ Folder Settings
            </NavLink>
          </li>

          <li className="theme-list-item">
            <ThemeSelector />
          </li>
        </ul>
      </nav>
    </aside>
  );
};

export default Sidebar;